/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useMediaQuery } from "@/shared/hooks/use-media-query";
import type { ToastType } from "./use-toast";
import {
  getMessageTextStyles
} from "./use-toast-message-helpers";

interface ToastMessageProps {
  message: string;
  technicalDetails: string | null;
  type: ToastType;
  title: string;
}


/**
 * ToastMessage component for displaying toast message.
 * 
 * @param {ToastMessageProps} props - Component props
 * @returns {JSX.Element} Toast message component
 */
export function ToastMessage({ message, technicalDetails, type, title }: ToastMessageProps): JSX.Element {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return <div style={getMessageTextStyles(!!technicalDetails, !!isMobile)}>{message}</div>;
}
